module.exports = __webpack_public_path__ + "img/Haru2.3ca9ad7a.png";